import clsx from "clsx";
import React, { useContext } from "react";

import { buyNowContext } from "../BuyNow";
import { PURCHASE_FLOWS } from "../../../../constants";

export const GuaranteesIcons = () => {
  const { portal, purchaseFlow } = useContext(buyNowContext);
  const isClinicianPage = [PURCHASE_FLOWS.CLEARSTEP_CLINICIAN, PURCHASE_FLOWS.SHAPA_HEALTH_CLINICIAN].includes(purchaseFlow);
  const clinicianIcons = ["live_tech_support.svg", "ai_analysis.svg", "30_day_moneyback.svg", "fsa_eligible.png"];
  const otherPagesIcons = ["lifetime_warranty.svg", "live_tech_support.svg", "same_day_shipping.svg", "30_day_moneyback.svg", "fsa_eligible.png"];

  return (
    <div className={clsx("mt-4 guarantees-icons", isClinicianPage ? "guarantees-4-icons" : "guarantees-5-icons" )}>
      {(isClinicianPage ? clinicianIcons : otherPagesIcons).map((icons) => {
        return (<img key={icons} alt={`${icons}-preview`} className="img-fluid-reversed" src={`/img/buyNow/guarantees/${portal}/${icons}`} />)
      })}
    </div>
  )
};
